<template>
  <div>
    <v-server-table @loaded="onLoaded" ref="table" :columns="columns" :options="options" :url="url" style="overflow: hidden;">
      <div slot="created_at" slot-scope="props">
        <span class="badge badge-success p-2">{{ formatDate(props.row.created_at) }}</span>
      </div>
      <div slot="utilisateur" slot-scope="props">
        <span v-if="!getIsEmptyHelper(props.row.original_user_id)">
            {{ getUserById(props.row.gestionnaire_original) }} en tant que {{ getUserById(props.row.gestionnaire) }}</span>
        <span v-else>{{ getUserById(props.row.gestionnaire) }}</span>
      </div>
      <div slot="old_value" slot-scope="props" class="slot-date">
        <span>{{ getValue(props.row, 'old_value') }}</span>
      </div>
      <div slot="new_value" slot-scope="props" class="slot-date">
        <span>{{ getValue(props.row, 'new_value') }}</span>
      </div>
    </v-server-table>
  </div>
</template>

<script>
import { isEmpty } from "@/utils/fileHelper"
import { formatDateTime } from "@/utils/communHelper"

export default {
  name: 'HistoriqueDocument',
  props: ['selectedDocument', 'datas'],
  // {
  //   selectedDocument: {
  //     document: Object
  //   },
  //   datas,
  // },
  data() {
    let self = this;
    return {
      columns: ['created_at', 'utilisateur', 'action', 'commentaire', 'old_value', 'new_value'],
      url: '',
      options: {
        headings: {
          'created_at': 'Date',
          'utilisateur': 'Utilisateur',
          'action': 'Action',
          'commentaire': 'Commentaire',
          'old_value': 'Ancienne valeur',
          'new_value': 'Nouvelle valeur'
        },
        filterable: false,
        perPage: 10,
        perPageValues: [1, 10, 25],
        sortable: ['created_at'],
        requestFunction: function (data) {
          self.url = '/espaceBibliotheque/document/getDocumentJournalById/' + self.selectedDocument.id;
          return axios.get(self.url, {
            params: data
          })
            .then(function(response){
              // console.log(response.data.data)
              return response;
            })
            .catch(function (e) {
              console.log(e);
            }.bind(this));
        },
      },
    }
  },
  methods: {
    onLoaded() {
      this.$store.commit("IS_LOADING", false);
    },
    getIsEmptyHelper(value) {
      return isEmpty(value)
    },
    getUserById(gestionnaire) {
      return gestionnaire ? `${gestionnaire.prenom} ${gestionnaire.nom}` : 'système';
    },
    formatDate(textDate) {
      // return textDate !== null ? new Date(textDate).toLocaleDateString("fr-FR") : "-";
      return formatDateTime(textDate, '/');
    },
    isRowDate(row) {
      if (row !== 0 || row !== 1) {
        let unixTimeStamp = Date.parse(row)
        if (!isNaN(unixTimeStamp)) {
          const dateObject = new Date(unixTimeStamp)
          return dateObject instanceof Date ? true : false
        }
      } else {
        return false
      }
    },
    getValue(suivi, type) {
      console.log('this.datas',this.datas)
      let libelle = '';
      switch (true) {
        case /statu/.test(suivi.commentaire) :
          let status = {};
          // console.log('this.datas.allStatus',this.datas.allStatus,suivi.old_value,suivi.new_value)
          if (type === 'old_value' && !isEmpty(suivi.old_value)) {
            status = this.datas.allStatus.find(sta => parseInt(sta.id,10) === parseInt(suivi.old_value,10));
          } else if (type === 'new_value') {
            status = this.datas.allStatus.find(sta => parseInt(sta.id,10) === parseInt(suivi.new_value,10));
          }
          // console.log('status',status)
          if (!isEmpty(status)) {
            libelle = status.libelle_bo;
          }
          break;
        case /categorie/.test(suivi.commentaire) || /catégorie/.test(suivi.commentaire) :
          let categorie = {};
          // console.log('this.datas.allcategorie',this.datas.allcategorie,suivi.old_value,suivi.new_value)
          if (type === 'old_value' && !isEmpty(suivi.old_value)) {
            categorie = this.datas.allCategories.find(cat => parseInt(cat.id,10) === parseInt(suivi.old_value,10));
          } else if (type === 'new_value') {
            categorie = this.datas.allCategories.find(cat => parseInt(cat.id,10) === parseInt(suivi.new_value,10));
          }
          // console.log('categorie',categorie)
          if (!isEmpty(categorie)) {
            libelle = categorie.libelle;
          }
          break;
        case /sous-rubrique/.test(suivi.commentaire) || /sous_rubrique/.test(suivi.commentaire) :
          let sousRubrique = {};
          // console.log('this.datas.allcategorie',this.datas.allcategorie,suivi.old_value,suivi.new_value)
          if (type === 'old_value' && !isEmpty(suivi.old_value)) {
            sousRubrique = this.datas.allSousRubriques.find(cat => parseInt(cat.id,10) === parseInt(suivi.old_value,10));
          } else if (type === 'new_value') {
            sousRubrique = this.datas.allSousRubriques.find(cat => parseInt(cat.id,10) === parseInt(suivi.new_value,10));
          }
          // console.log('categorie',categorie)
          if (!isEmpty(sousRubrique)) {
            libelle = sousRubrique.libelle;
          }
          break;
        case /rubrique/.test(suivi.commentaire) :
          let rubrique = {};
          // console.log('this.datas.allcategorie',this.datas.allcategorie,suivi.old_value,suivi.new_value)
          if (type === 'old_value' && !isEmpty(suivi.old_value)) {
            rubrique = this.datas.allRubriques.find(cat => parseInt(cat.id,10) === parseInt(suivi.old_value,10));
          } else if (type === 'new_value') {
            rubrique = this.datas.allRubriques.find(cat => parseInt(cat.id,10) === parseInt(suivi.new_value,10));
          }
          // console.log('categorie',categorie)
          if (!isEmpty(rubrique)) {
            libelle = rubrique.libelle;
          }
          break;
        case /segment/.test(suivi.commentaire) :
          let segment = {};
          // console.log('this.datas.allcategorie',this.datas.allcategorie,suivi.old_value,suivi.new_value)
          if (type === 'old_value' && !isEmpty(suivi.old_value)) {
            segment = this.datas.allSegments.find(cat => parseInt(cat.id,10) === parseInt(suivi.old_value,10));
          } else if (type === 'new_value') {
            segment = this.datas.allSegments.find(cat => parseInt(cat.id,10) === parseInt(suivi.new_value,10));
          }
          // console.log('categorie',categorie)
          if (!isEmpty(segment)) {
            libelle = segment.libelle;
          }
          break;
        case /famille produit/.test(suivi.commentaire) || /gamme_produit/.test(suivi.commentaire) :
          let produit = {};
          // console.log('this.datas.allcategorie',this.datas.allcategorie,suivi.old_value,suivi.new_value)
          if (type === 'old_value' && !isEmpty(suivi.old_value)) {
            produit = this.datas.allGammesProduit.find(cat => parseInt(cat.id,10) === parseInt(suivi.old_value,10));
          } else if (type === 'new_value') {
            produit = this.datas.allGammesProduit.find(cat => parseInt(cat.id,10) === parseInt(suivi.new_value,10));
          }
          // console.log('categorie',categorie)
          if (!isEmpty(produit)) {
            libelle = produit.libelle;
          }
          break;
        default:
          libelle = type === 'old_value' ? suivi.old_value : (type === 'new_value' ? suivi.new_value : '');
      }
      // console.log('libelle',libelle)
      return libelle;
    },
  }
}
</script>
